//
// Copyright (c) 2026 Comcast
//

import { StyleSheetManager } from 'styled-components'
import isPropValid from '@emotion/is-prop-valid'
import { RouterProvider, createBrowserRouter } from 'react-router'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { store } from 'store'
import { initRouterListener } from 'listeners/router'
import App from 'components/App/Index'
import './i18n'
import 'assets/stylesheets/main.sass'

const shouldForwardProp = (propName, target) => {
  if (typeof target === 'string') {
    return isPropValid(propName)
  }

  return true
}

const router = createBrowserRouter([
  { path: '*', element: <App /> },
])

// initialize router listener bridge after router and store are ready
initRouterListener(store, router)

createRoot(document.getElementById('application-content')).render(
  <Provider store={store}>
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <RouterProvider router={router} />
    </StyleSheetManager>
  </Provider>
)
